import React, { useCallback, useMemo } from 'react'
import { MarkerF, PolygonF } from '@react-google-maps/api'
import { LatLng, PositionType } from '../../../types/geofence.type'

type PolygonMapperProps = {
    coordinates?: PositionType[]
    updatePoint?: (index: number, coordinate: LatLng) => void
    isEdit?: boolean
}
export const PolygonMapper = (props: PolygonMapperProps) => {
    const paths = useMemo(() => {
        if (props?.coordinates) {
            return props?.coordinates?.map(
                (point) =>
                    new google.maps.LatLng({
                        lat: point.latitude,
                        lng: point.longitude,
                    })
            )
        } else {
            return []
        }
    }, [props?.coordinates])

    const onDragMarker = useCallback(
        (index: number) => (mapEvent: google.maps.MapMouseEvent) => {
            const { latLng } = mapEvent
            const latitude = latLng?.lat()
            const longitude = latLng?.lng()
            if (latitude && longitude)
                props?.updatePoint?.(index, { latitude, longitude })
        },
        [paths]
    )

    if (props?.coordinates) {
        const { coordinates } = props
        return (
            <>
                {props?.isEdit &&
                    coordinates.map((position, index) => {
                        return (
                            <MarkerF
                                key={position.order}
                                position={paths[index]}
                                draggable
                                onDrag={onDragMarker(index)}
                            />
                        )
                    })}
                {coordinates.length > 0 && (
                    <PolygonF
                        options={{
                            fillColor: 'rgba(242, 100, 90,0.5)',
                            strokeColor: 'blue',
                            strokeWeight: 2,
                        }}
                        path={paths}
                    />
                )}
            </>
        )
    } else {
        return <></>
    }
}
